import { render, staticRenderFns } from "./DrawerError.vue?vue&type=template&id=48553176&"
import script from "./DrawerError.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DrawerError.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48553176')) {
      api.createRecord('48553176', component.options)
    } else {
      api.reload('48553176', component.options)
    }
    module.hot.accept("./DrawerError.vue?vue&type=template&id=48553176&", function () {
      api.rerender('48553176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSelectionDrawer/components/DrawerError.vue"
export default component.exports